package com.tovtalk.domain.repository

import com.tovtalk.domain.entity.DomainResult

/**
 * Auth Manager Interface for platform-specific authentication (Firebase)
 */
interface AuthManager {
    /**
     * Sign in to Firebase with Google ID token and return Firebase ID token.
     * @param googleIdToken The Google Sign-In ID token
     * @param googleAccessToken Optional access token (required on iOS for GitLive Firebase)
     * @return Firebase ID token on success
     */
    suspend fun signInWithGoogleAndGetFirebaseToken(googleIdToken: String, googleAccessToken: String? = null): DomainResult<String>
    
    suspend fun signInWithEmailAndPassword(email: String, password: String): DomainResult<Unit>
    
    /**
     * Sign in to Firebase with custom token (for email users - enables Firestore/chat)
     */
    suspend fun signInWithCustomToken(customToken: String): DomainResult<Unit>
    
    /**
     * Get current Firebase ID token (refreshes if needed)
     */
    suspend fun getFirebaseIdToken(): DomainResult<String>
    
    fun signOut()
    fun getCurrentUserId(): String?

    /**
     * On Web: after returning from Google redirect, returns the Firebase token if any.
     * On Android/iOS: always null.
     */
    suspend fun getRedirectResultFirebaseTokenIfAny(): DomainResult<String>? {
        return null
    }
}
